import { createRouter, createWebHistory } from 'vue-router'
import { TOKEN } from '@/constants/storage'
import { useSystemStore } from '@/stores/index'
import Storage from '@/utils/storage'

const routes = [
  {
    path: '/',
    component: () => import('@/views/home/home.vue').catch(() => location.reload()),
  },
  {
    path: '/redirect',
    component: () => import('@/views/home/home.vue').catch(() => location.reload()),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/operation',
    component: () => import('@/views/operation/operation.vue').catch(() => location.reload()),
    meta: {
      title: '运营推广',
    },
  },
  {
    path: '/cooperation',
    component: () => import('@/views/cooperation/cooperation.vue').catch(() => location.reload()),
    meta: {
      title: '合作案例',
    },
  },
  {
    path: '/about',
    component: () => import('@/views/about/about.vue').catch(() => location.reload()),
    meta: {
      title: '关于我们',
    },
  },
  {
    path: '/about-nol',
    component: () => import('@/views/about/about.vue').catch(() => location.reload()),
    meta: {
      title: '关于我们',
    },
  },
  {
    path: '/city-partner',
    component: () => import('@/views/city-partner/index.vue').catch(() => location.reload()),
    meta: {
      title: '城市合伙人',
    },
  },
  {
    path: '/letter-sheet',
    component: () => import('@/views/letter-sheet/index.vue').catch(() => location.reload()),
    meta: {
      title: '供应链票据',
    },
  },
  {
    path: '/login',
    component: () => import('@/views/login/login.vue').catch(() => location.reload()),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/register',
    component: () => import('@/views/register/register.vue').catch(() => location.reload()),
    meta: {
      title: '注册',
    },
  },
  {
    path: '/reset-password',
    component: () => import('@/views/reset-password/reset-password.vue').catch(() => location.reload()),
    meta: {
      title: '重置密码',
    },
  },
  {
    path: '/partner-joined',
    component: () => import('@/views/city-partner/partner-joined.vue').catch(() => location.reload()),
    meta: {
      title: '城市合伙人已入驻',
      requiredAuth: true,
    },
  },
  // 不存在的路由跳转
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 切换路由时，让页面返回顶部
router.beforeEach(async (to, from) => {
  // 设置返回顶部
  document.documentElement.scrollTop = 0
  let token = Storage.get(TOKEN)
  if (to.meta.requiredAuth && !token) {
    return '/login'
  } else if (to.path === '/login' && token) {
    return from.path
  } else {
    return true
  }
})
router.afterEach((to) => {
  const systemStore = useSystemStore()
  systemStore.showHeader = !['/about-nol', '/partner-joined'].includes(to.path)
  systemStore.showFooter = !['/login', '/register', '/reset-password', '/about-nol', '/partner-joined'].includes(to.path)
})

/**
 * 为路由配置对象设置全局参数
 * @param {object[]} routerObj 路由对象数组
 * @param {object} commonMeta 需要统一设置的 meta
 * @param {boolean} commonMeta.requiredLogin 访问当前页面是否需要登录
 * @param {object} commonMeta.title 标题
 * @param {object} commonMeta.code 唯一标识
 * @param {object} commonMeta.showInMenu 是否显示在菜单中
 * @param {string[]} ignore 需要忽略的路由名称
 */
export function setCommonMeta(routerObj, commonMeta, ignore) {
  routerObj.forEach((item) => {
    const isIgnored = ignore && ignore.length && item.name && ignore.includes(item.name)
    if (!isIgnored) {
      item.meta = Object.assign({}, commonMeta, item.meta)
    }
    if (item.children && item.children.length > 0) {
      setCommonMeta(item.children, commonMeta, ignore)
    }
  })
}

export default router
